import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpensesDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M26.613 15.0087L35.8029 14.5913M27.7796 17.6531L37.2684 17.1086M28.909 20.2397L33.6534 19.9675",
			stroke: "white",
			strokeOpacity: .24,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.36582 5.12358C5.04757 5.12358 2.99741 12.5592 2.07167 17.3656C1.91512 18.1785 2.82078 18.7507 3.50285 18.2817V18.2817C3.97579 17.9565 4.59847 17.9497 5.07835 18.2646L5.47095 18.5222C5.97241 18.8513 6.62423 18.8396 7.11359 18.4928L7.44304 18.2593C7.85785 17.9654 8.42697 18.0281 8.76772 18.4055V18.4055C9.10876 18.7831 9.67849 18.8456 10.0933 18.5509L10.6789 18.1349C10.9823 17.9194 11.4032 17.9921 11.6166 18.297V18.297C11.8809 18.6744 12.4383 18.679 12.7088 18.306L13.1165 17.7439M9.36582 5.12358C11.8775 3.32698 20.1084 2.35906 23.1362 4.49326C24.9216 6.08071 25.1116 8.61366 25.1904 10.3396M9.36582 5.12358C13.1886 5.12358 13.2882 12.9158 13.1165 17.7439M22.1256 11.088C17.1451 11.088 18.4986 23.4741 14.5972 23.4741C13.0599 23.4741 13.0048 20.8835 13.1165 17.7439M22.1256 11.088C24.2275 11.088 25.4103 19.546 26.6416 24.9011C28.4311 32.6847 30.0982 41.5455 32.3013 44.372C32.457 44.5718 32.7497 44.556 32.9114 44.3611L33.0475 44.1972C33.4237 43.7439 34.0946 43.6778 34.5521 44.049L34.6586 44.1354C35.0598 44.4609 35.6488 44.4004 35.9756 44.0002V44.0002C36.2674 43.6426 36.7761 43.5507 37.1747 43.7834L37.3838 43.9056C37.7869 44.141 38.3044 44.0088 38.5452 43.609V43.609C38.7708 43.2344 39.2429 43.091 39.6387 43.2767L40.2113 43.5453C40.5535 43.7059 40.959 43.6417 41.2349 43.3835V43.3835C41.514 43.1222 41.9251 43.0599 42.2691 43.2267L42.8531 43.5098C43.2185 43.687 43.6575 43.5929 43.9183 43.2817V43.2817C44.194 42.9526 44.6661 42.8686 45.0383 43.0825L45.3242 43.2468C45.6653 43.4428 46.0797 43.1074 45.9718 42.7291C44.8507 38.7999 43.3174 30.7433 41.6483 23.4741C40.8699 20.0842 39.854 16.7272 38.8928 14.0773C38.0018 11.6209 36.0115 9.68682 33.4056 9.4961C30.6103 9.29154 27.4554 9.66198 25.1904 10.3396M22.1256 11.088C23.7664 10.5618 25.1904 10.3396 25.1904 10.3396",
			stroke: "white",
			strokeOpacity: .24,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9375 7.99597L20.5068 7.47388",
			stroke: "white",
			strokeOpacity: .24,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9375 10.6937L20.5068 10.1716",
			stroke: "white",
			strokeOpacity: .24,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.3045 35.9626C32.1574 36.9292 32.3297 38.8625 34.1957 38.8625C36.5282 38.8624 40.0585 33.7561 37.8521 33.7561C35.6457 33.7561 35.0153 38.169 40.815 38.169",
			stroke: "#A8AAE3",
			strokeLinecap: "round"
		})
	]
});
export default SvgExpensesDark;
